module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/1c27fb53ef636f6b32679156f314fa43.png";